<template>
  <div class="forget">
    <div class="simple-page">
      <div class="app-content">
        <div style="height: 100%;">
          <div class="app-scrollbar-content">
            <div class="simple-container content-wh" style="flex: 0 1 auto;min-height: calc(100% - 130px);">
              <div class="home-forget">
                <form>
                  <!--                  <div class="forget-title">-->
                  <!--                    <i class="icon icon-exclamation-sign" style="color: #0a2b69 !important;"></i> 忘记密码-->
                  <!--                  </div>-->
                  <div style="margin: 0px 15%;position: relative">
                    <img @click="success" src="/img/login/blue_link_small.png"
                         style=" cursor: pointer;margin-left: -4px; width: 94px;">
                    <span style="margin-left: 24px;margin-right: 6px">|</span><span>忘记密码</span>
                    <span style="position: absolute;right: 0px;">重置成功？前往
                   <span class="tologin" @click="success">[登录]</span></span>
                  </div>

                  <div class="forget-form">
                    <form>
                      <div class="forget-form-item">
                        <div class="forget-form-title is-required">用户名
                        </div>
                        <div class="forget-form-inputs">
                          <div class="zui-input zui-input--medium" style="width: 300px;">
                            <input type="text" v-model="forgetForm.userName" @blur="telCheck2" placeholder="请输入用户名"
                                   maxlength="11" class="zui-input__inner">
                          </div>
                          <span style="color: #2176b4;font-size:20px;margin-left: 3px;"  id="userNameSuccess" hidden="hidden">
                            <i class="el-icon-circle-check"></i>
                          </span>
                          <!-- input失去焦点判断输入的手机号是否正确   -->
                          <div class="forget-form-title is-required" style="color: red;" icon="el-icon-circle-check">{{ userName_Loading }}
                          </div>
                          <i style="display:none" class="icon icon-exclamation-sign" id="username" data-container="body"
                             data-original-title="" data-toggle="tooltip" data-placement="right">
                          </i>
                        </div>
                      </div>
                      <div class="forget-form-item">
                        <div class="forget-form-title is-required">电话
                        </div>
                        <div class="forget-form-inputs">
                          <div class="zui-input zui-input--medium" style="width: 300px;">
                            <input type="text" v-model="forgetForm.phone" placeholder="手机号码" @blur="telcheck_zi"
                                   maxlength="11" class="zui-input__inner">
                          </div>
                          <span style="color: #2176b4;font-size:20px;margin-left: 3px;"  id="phoneSuccess" hidden="hidden">
                            <i class="el-icon-circle-check"></i>
                          </span>
                          <!-- input失去焦点判断输入的手机号是否正确   -->
                          <div class="forget-form-title is-required" style="color: red;">{{ phone_Loading }}
                          </div>
                          <i style="display:none" class="icon icon-exclamation-sign" id="tel" data-container="body"
                             data-original-title="" data-toggle="tooltip" data-placement="right">
                          </i>
                        </div>
                      </div>
                      <div class="forget-form-item">
                        <div class="forget-form-title is-required">验证码</div>
                        <div class="forget-form-inputs">
                          <div class="zui-input zui-input--medium" style="width: 222px; margin-right: 10px;">
                            <input type="text" v-model="forgetForm.code" @blur="codeSure" placeholder="请输入验证码"
                                   maxlength="6" class="zui-input__inner">
                          </div>

                          <Button @click="getVerifyCode" id='button1' style="padding: 0;text-align: center;"
                                  v-if="time!==0 && time!==60">{{ time }}
                          </Button>
                          <Button @click="getVerifyCode" id='button1' style="padding: 0;text-align: center;" v-else>
                            发送验证码
                          </Button>

                          <!--                          <span v-if="showbtn" @click="getVerifyCode"-->
                          <!--                                class="verifiy-code is-required">{{ btnTitle }}</span>-->
                          <!--                          <span v-if="!showbtn" class="verifiy-code is-required" id="new_yan">{{ btnTitle }}</span>-->

                          <span style="color: #2176b4;font-size:20px;margin-left: 3px;"  id="codeSuccess" hidden="hidden">
                            <i class="el-icon-circle-check"></i>
                          </span>
                          <i style="display:none" class="icon icon-exclamation-sign" id="Code" data-container="body"
                             data-original-title="" data-toggle="tooltip" data-placement="right">
                          </i>


                        </div>
                      </div>
                      <div class="forget-form-item">
                        <div class="forget-form-title is-required">密码</div>
                        <div class="forget-form-inputs">
                          <div class="zui-input zui-input--medium" style="width: 300px;">
                            <input type="password" v-model="forgetForm.password" @blur="pwdCheck"
                                   placeholder="6~20个字符，可输入字母、数字和下划线" maxlength="20" class="zui-input__inner">
                          </div>
                          <span style="color: #2176b4;font-size:20px;margin-left: 3px;"  id="password1Success" hidden="hidden">
                            <i class="el-icon-circle-check"></i>
                          </span>
                          <i style="display:none" class="icon icon-exclamation-sign" id="pwd" data-container="body"
                             data-original-title="" data-toggle="tooltip" data-placement="right">
                          </i>
                        </div>
                      </div>
                      <div class="forget-form-item">
                        <div class="forget-form-title is-required">确认密码</div>
                        <div class="forget-form-inputs">
                          <div class="zui-input zui-input--medium" style="width: 300px;">
                            <input type="password" v-model="forgetForm.password1" @blur="pwdSure" placeholder="请重新输入密码"
                                   maxlength="20" class="zui-input__inner">
                          </div>
                          <span style="color: #2176b4;font-size:20px;margin-left: 3px;"  id="password2Success" hidden="hidden">
                            <i class="el-icon-circle-check"></i>
                          </span>
                          <i style="display:none" class="icon icon-exclamation-sign" id="password1"
                             data-container="body" data-original-title="" data-toggle="tooltip" data-placement="right">
                          </i>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="forget-btn">
                    <button @click="ForgetSubmit()" type="button"
                            class="zui-button zui-button--primary zui-button--medium">
                      <span> 确认 </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="aitexts-footer">-->
        <!--          <div class="footer-content content-wh">-->
        <!--            <div class="footer-el">-->
        <!--              <div class="footer-logo">-->
        <!--                <nuxt-link to="/"><img src="/img/login/link.png" style="width:150px;height:150px;margin: 13px 5px 0 5px;" /></nuxt-link>-->
        <!--              </div>-->
        <!--              <div class="footer-addr">-->
        <!--                <div class="addr">Copyright © 2014-2024 Shanghai Jing He</div>-->
        <!--                <div class="addr">Tel：(+86)021-66181082 E-mail：dataservice@aitexts.com</div>-->
        <!--                <div class="addr">All Rights Reserved</div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash; <div class="footer-code"><img src="/img/login/aitexts-code.jpg"></div> &ndash;&gt;-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import forget from "./forget";

let timer
import axios from "../api/axios";

export default {
  layout: 'forget',
  name: 'forget',
  data() {
    return {
      userNameIsTrue:false,
      showbtn: true,//展示获取验证码或倒计时按钮判断
      userNamePhone_flag: false, //用户名和密码是否输入正确来判断
      code_flag: false, //验证码是否输入正确来判断
      time: 60,
      //用户名错误警告信息
      userName_Loading: "",
      phone_Loading: "",
      btnTitle: '获取验证码', //input框中的文字
      isvalidatePhone: false,//手机号码问题是否测试通过
      forgetForm: {
        userName: '',
        phone: '',
        code: ' ',
        password: '',
        password1: '',
      }
    }
  },
  mounted: function () {
    $('#tel').tooltip({});
    $('#Code').tooltip({});
    $('#pwd').tooltip({});
    $('#password1').tooltip({});
  },
  methods: {
    success() {
      // 更改store中的值
      this.$store.commit('setRegisterFlag', {
        flag: false,
        flag2: false,
      })
    },

    validPhone(){
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if(!reg.test(this.forgetForm.phone.trim())){
        return false;
      }else {
        return true;
      }
    },

    //验证用户名
    async telCheck2() {
      if (this.forgetForm.userName.trim() === "") {
        this.userName_Loading = "请输入用户名";
        $("#userNameSuccess").hide();
        return false;
      } else {
        var a = false;
        await axios.post("/api/register/chechUserName", {
          userName: this.forgetForm.userName.trim()
        }).then((res) => {
          //true
          if (res.data.status) {
            $("#userNameSuccess").show();
            this.userName_Loading = "";
            a = true;
          } else {
            //false
            this.userName_Loading = "未查询到该用户";
            $("#userNameSuccess").hide();
            a = false;
          }
        })
        return a;
      }
    },


    //验证手机号
    async telcheck_zi() {
      var resUserName = await this.telCheck2();
      var resultThis=false;
      if (resUserName) {
        var result = this.validPhone();
        if (result) {
          await axios.post("/api/register/getUserTel", {
            userName: this.forgetForm
          }).then((res) => {
            if (res.data.status) {
              this.phone_Loading = "";
              $("#phoneSuccess").show();
              resultThis=true;
            } else {
              this.phone_Loading = "手机号不匹配";
              $("#phoneSuccess").hide();
            }
          })
        } else {
          this.phone_Loading = "手机号错误";
          $("#phoneSuccess").hide();
        }
      }
      return resultThis;
    },
    //send验证码
    getVerifyCode: async function () {
      var isPhoneSuccess = await this.telcheck_zi();
      if(isPhoneSuccess){
        this.validatePhone();
      }
    },
    validatePhone: function () {
      axios.post("/api/register/sendPhoneMessagePassword", {
        phone: this.forgetForm.phone,
      }).then((res) => {
        if (res.data.status) {
          $('#button1')[0].disabled = true
          // 发送短信后启动定时器
          this.setTime = setInterval(() => {
            //console.log(this.time)
            if (this.time > 0) {
              this.time--
            }
            if (this.time === 0) {
              $('#button1')[0].disabled = false
              clearInterval(this.setTime)
              this.time = 60
            }
          }, 1000);
          this.$Message.success(res.data.msg)
        } else {
          this.$Message.error(res.data.msg)
        }
      }).catch(() => {
        this.$Message.error("短信发送失败")
      })
    },
    //开始验证验证码
    validateBtn: function () {
      //倒计时
      timer = setInterval(() => {
        if (this.time == 0) {
          clearInterval(timer);
          timer = null;
          this.showbtn = true;
          this.btnTitle = "获取验证码";
        } else {
          this.showbtn = false;
          this.btnTitle = this.time + '秒后重试';
          this.time--
        }
      }, 1000)
    },

    //验证验证码字段
    codeSure: async function () {
      var red=false;
      await axios.post("/api/register/validCode", {
        code: this.forgetForm.code
      }).then((res) => {
        if (res.data.data === '验证成功') {
          $("#codeSuccess").show();
          red = true;
        } else {
          $("#codeSuccess").hide();
          red = false;
        }
      })
      return red;
    },
    //验证密码字段
    pwdCheck: function () {
      let reg = /^[0-9a-zA-Z_]{6,20}$/;
      if (this.forgetForm.password.length == 0) {
        $("#pwd").attr('data-original-title', '请输入密码')
        $("#pwd").css('display', 'block')
        $("#password1Success").hide();

      } else if (this.forgetForm.password.length < 6) {
        $("#pwd").attr('data-original-title', '密码长度不能小于6位')
        $("#pwd").css('display', 'block')
        $("#password1Success").hide();

      } else if (reg.test(this.forgetForm.password)) {
        $("#pwd").css('display', 'none')
        $("#password1Success").show();

      }
    },
    //验证确认密码字段
    pwdSure: function () {
      if (this.forgetForm.password1.length == 0) {
        $("#password2Success").hide();
        return false;
      } else if (this.forgetForm.password.trim() !== this.forgetForm.password1.trim()) {
        $("#password2Success").hide();
        return false;
      }else if(this.forgetForm.password.trim() === this.forgetForm.password1.trim()){
        $("#password2Success").show();
        return true;
      }
    },
    ForgetSubmit: async function () {
      //判断两次输入的密码是否一致
      var result1 = await this.codeSure();
      var isPhoneSuccess = await this.telcheck_zi();
      var result2 = this.pwdSure();
      if (result1 && result2 && isPhoneSuccess) {
        axios.post("/api/register/validCode", {
          code: this.forgetForm.code
        }).then((res) => {
          if (res.data.data === '验证成功') {
            let data = {"userName": this.forgetForm.userName, "newPassword": this.forgetForm.password1};
            axios.post("/api/register/resetPassword", {
              data: data
            }).then((res) => {
              if (res.data.msg === '重置成功') {
                this.$Message.success('重置成功')
                this.success();
              } else if (res.data.msg === '与原密码一致') {
                this.$Message.error('与原密码一致')
              } else {
                this.$Message.error('重置失败')
              }
            })
          }
        })
      }else {
        this.$Message.error('请将信息补充完整')
      }
    }
  }
}
</script>

<style scoped>
.forget {
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  overflow-x: auto;
}

.simple-page {
  height: 100%;
}

.aitexts-header {
  height: 60px;
  background: #0a2b69;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.content-wh {
  width: 70%;
  min-width: 1180px;
}

.app-content {
  height: calc(100% - 60px);
  background: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

.simple-page .app-scrollbar-content {
  display: flex;
  flex-direction: column;
}

.simple-page .simple-container {
  margin: 0 auto;
  padding: 30px 0;
  min-height: calc(100% - 130px);
}

.content-wh {
  width: 70%;
  min-width: 1180px;
}

.home-forget .forget-title {
  font-size: 16px;
  color: #0a2b69;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f2f2f2;
  font-weight: 700;
}

.home-forget .forget-title i {
  font-size: 18px;
}

.forget-form {
  margin-top: 5%;
  margin-left: 30%;
}

.forget-form-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.home-forget .forget-form .forget-form-item .forget-form-title {
  width: 120px;
  text-align: right;
  padding-right: 10px;
  color: #333;
}

.home-forget .forget-form .forget-form-item .forget-form-title.is-required:before {
  color: #c00;
  margin-left: 1px;
}

.forget-form-inputs {
  display: flex;
  align-items: center;
}

.zui-input--medium {
  font-size: 14px;
}

.zui-input {
  position: relative;
  display: inline-block;
}

.zui-input--medium .zui-input__inner {
  height: 36px;
  line-height: 36px;
}

.zui-input__inner {
  border-radius: 0;
  border-color: #e6e6f6;
}

.zui-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: none;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}

.home-forget .forget-form .forget-form-item .forget-form-inputs .verifiy-code {
  width: 170px;
  border: 1px solid #b7a57a;
  color: #b7a57a;
  background: #fefbf5;
  height: 36px;
  line-height: 36px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}

.home-forget .forget-btn {
  margin-top: 1%;
  margin-left: 47%;
}

.zui-button--medium {
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 4px;
}

.zui-button--primary {
  color: #fff;
  background-color: #0a2b69;
  border-color: #0a2b69;
}

.zui-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: .1s;
  font-weight: 500;
}

.aitexts-footer {
  display: flex;
  align-items: center;
  /* height: 170px; */
  color: #6a6a72;
  background: #0a2b69;
  justify-content: center;
  font-size: 12px;
  flex: 0 0 auto;
  z-index: 10;
}

.content-wh {
  width: 70%;
  min-width: 1180px;
}

.aitexts-footer,
.aitexts-footer .footer-el {
  display: flex;
  align-items: center;
}

.aitexts-footer .footer-el .footer-addr {
  flex: 1;
  color: #fff;
}

.aitexts-footer .footer-el .footer-addr .addr {
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  font-family: "宋体 Bold", "宋体 常规";
}

.aitexts-footer .footer-el .footer-logo img {
  width: 100px;
}

.aitexts-footer .footer-el .footer-code img {
  height: 90px;
}

.icon.icon-exclamation-sign {
  /* position: absolute; */
  right: -20px;
  color: #c00;
  margin-left: 12px;
}


/* 禁止验证码点击 */

#new_yan {
  pointer-events: none;
}
</style>
